export class UpdateUserMfaRequiredRequest {
    id: number; // UserId
    newStatus: boolean;

    constructor() {}
}